import { cn } from './cn';
import { initiales } from './initiales';

export function Avatar({
  nom,
  photo,
  className,
}: {
  nom: string;
  photo?: string | null | undefined;
  className?: string;
}) {
  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        aria-hidden
        className={cn('size-9 shrink-0 rounded-full bg-primary-subtle object-cover', className)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        'grid size-9 shrink-0 place-items-center rounded-full bg-primary-subtle text-[13px] font-semibold text-primary',
        className
      )}
    >
      {initiales(nom)}
    </span>
  );
}
